import { ChangeEvent, FC } from 'react';
import {
  LinkConfigurationsOutputData,
  OpenInputType,
  SubscriptionInputType,
} from '../../../../middlewares/Open/openTypes';
import TextField from '../Fields/TextField';
import SelectField from '../Fields/SelectFields';

interface SubscriptionConfigurationsInputFieldProps {
  linkConfiguration: LinkConfigurationsOutputData;
  displayInputs: SubscriptionInputType;
  dismissedFields: { [key: string]: boolean };
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  errors: { [key: string]: string | null };
  inputs?: OpenInputType;
  onDismissField: (name: string, dismiss: boolean) => void;
  handleRemoteChange?: (name: string, value: string | number) => void;
}

const SubscriptionConfigurationsInputField: FC<
  SubscriptionConfigurationsInputFieldProps
> = (props) => {
  const {
    linkConfiguration,
    displayInputs,
    dismissedFields,
    errors,
    handleChange,
    // inputs,
    onDismissField,
    // handleRemoteChange,
  } = props;

  const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    const syntheticTarget = {
      name: name,
      value: value,
    } as unknown as HTMLInputElement;

    const syntheticEvent = {
      target: syntheticTarget,
      currentTarget: syntheticTarget,
      type: e.type,
    } as ChangeEvent<HTMLInputElement>;

    handleChange(syntheticEvent);
  };

  const fieldTypeDict = {
    'LinkConfigurations::Subscription::ChargeDateSelect': (
      <SelectField
        key={linkConfiguration.id}
        inputs={displayInputs}
        linkConfiguration={linkConfiguration}
        dismissed={dismissedFields[linkConfiguration.name]}
        onDismissField={onDismissField}
        error={errors[linkConfiguration.name]}
        optionLabel="days"
        handleChange={handleSelectChange}
      />
    ),
  };

  if (linkConfiguration.customFieldType in fieldTypeDict) {
    return fieldTypeDict[
      linkConfiguration.customFieldType as keyof typeof fieldTypeDict
    ];
  }
  return (
    <TextField
      key={linkConfiguration.id}
      inputs={displayInputs as OpenInputType}
      linkConfiguration={linkConfiguration}
      dismissed={dismissedFields[linkConfiguration.name]}
      onDismissField={onDismissField}
      error={errors[linkConfiguration.name]}
    />
  );
};

export default SubscriptionConfigurationsInputField;
